import axios from 'axios'
import globalStore from '@/stores/global.svelte'

type BirthdaySchedule = {
  active: boolean,
  use_name: boolean,
  message: string,
  group_ids: Array<number>,
  send_time: string,
  coupon_id: number,
  coupon: {}
}

class BirthdaysStore {
  state = $state<{
    birthdaySchedule: BirthdaySchedule | {}
  }>({
    birthdaySchedule: {
      message: '',
      send_time: '',
      coupon_id: null
    }
  });

  fetch() {
    return axios.get('/birthday_schedules.json')
      .then((response) => {
        this.state.birthdaySchedule = response.data
        globalStore.setErrors([])
        return response.data
      })
      .catch((error) => {
        globalStore.setErrors(error)
        throw error
      })
  }

  getCountForUpdates({ group_ids }) {
    return axios.post(`/birthday_schedules/request_updates_count.json`, {
      group_ids
    })
      .then(response => {
        globalStore.setErrors([])
        return response.data
      })
      .catch(error => {
        globalStore.setErrors(error)
        return error
      })
  }

  sendUpdateRequests(data) {
    console.log('in sendUpdateRequests, data', data)
    return axios.post(`/birthday_schedules/request_updates.json`, {
      group_ids: data.group_ids
    })
      .then(response => {
        globalStore.setErrors([])
        return response.data
      })
      .catch(error => {
        globalStore.setErrors(error)
        return error
      })
  }

  update({ id, params }) {
    return axios.put(`/birthday_schedules/${id}.json`, {
      birthday_schedule: params
    })
      .then(response => {
        this.state.birthdaySchedule = response.data.birthday_schedule
        globalStore.setErrors([])
        return response.data
      })
      .catch(error => {
        globalStore.setErrors(error)
        return error
      })
  }
}

const birthdayStore = new BirthdaysStore()
export default birthdayStore
